import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { queryClient } from 'providers';

const { BulkGroupRegistrationBooking } = TransectionApiServices();

export const useCreateBooking = () => {
  const { message } = App.useApp();

  return useMutation(
    ({ payload, action }: { payload: any; action: string }) => {
      return BulkGroupRegistrationBooking(payload, action);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: eventsQueryKeys.all,
        });
        message.success("Booking has been created successfully!!");
      },
    }
  );
};